/* eslint-disable react-hooks/exhaustive-deps */
import { Card, FooterMenu, Pagination } from "components"
import moment from "moment"
import { useFilter } from "pages/Finance/Journal/utils/hooks"
import { Fragment, useEffect, useState } from "react"
import { SuccessFetch } from "types"
import { useApi } from "utils"
import { exportPdf, prevYear, thisMonth, thisWeek, thisYear, today } from "utils/functions"
import { PaginationType, RegisterDateType } from "../../types"
import { DropdownReference } from "../DropdownReference"
import { FilterByDate } from "../FilterByDate"
import { TableRegister } from "../TableRegister"
import { FooterSummary } from "../FooterSummary"
import { ExportExcel } from "../ExportExcel"
import { ExportPdf } from "../ExportPdf"

// Contexts
import { RowIndexContext } from "../../contexts"
import { usePagination } from "../../utils/hooks"
import { PERMISION } from "security"

type Response = {
  payload: {
    register_data: RegisterDateType[]
    pagination: PaginationType
  }
}

export function RegisterReference() {
  const api = useApi()
  const todayDate = today()
  const prevYearDate = prevYear()
  const thisYearDate = thisYear()
  const thisMonthDate = thisMonth()
  const thisWeekDate = thisWeek()
  const [data, setData] = useState<RegisterDateType[]>([])
  const [isLoading, setLoading] = useState(false)

  const {
    currentPage,
    limit,
    size,
    totalPage,
    total,
    getRowNumber,
    onChangeLimit,
    onChangePage,
    onChangePaginationData,
    resetPage
  } = usePagination()


  const { filter, handleChangeFilter } = useFilter({
    ReferenceCode: "",
    dateFrom: thisMonthDate.fromDate,
    dateTo: todayDate
  })

  const fetch = () =>
    api
      .postForm(`/regbydatarange/getdatabyref?page=${currentPage}&limit=${limit}`, {
        ReferenceCode: filter.ReferenceCode && filter.ReferenceCode !== "" ? filter.ReferenceCode : undefined,
        StartDate: filter.dateFrom,
        EndDate: filter.dateTo
      })
      .then((res: SuccessFetch<Response>) => {
        const data = res.data.payload

        onChangePaginationData(data.pagination)

        setData(
          data.register_data?.map((item) => ({
            ...item,
            checked: false
          })) ?? []
        )
      }).catch((error) => {
        const message = error.response?.data?.message || "Invalid data"
        console.log(message);
      }).finally(() => {
        setLoading(false)
      })

  useEffect(() => {

    resetPage()
    fetch()

  }, [filter, limit])

  useEffect(() => {
    fetch()
  }, [currentPage])

  const handleCheckData = (index: number) => {
    const newData = [...data]
    data[index].checked = !data[index].checked

    setData(newData)
  }

  return (
    <Fragment>
      <section className="mt-2 bg-white">
        <Card>
          <Card.Body>
            <section className="container flex-col lg:flex lg:flex-row justify-center lg:justify-between">
              <div className="w-full lg:w-1/2 flex-col lg:flex lg:flex-row justify-center lg:justify-start items-center">
                <div className="label-text pb-1 font-bold pe-6">Reference</div>
                <DropdownReference
                  value={null}
                  onChange={(item) =>
                    handleChangeFilter({ ReferenceCode: item?.value })
                  }
                />
              </div>
            </section>
            <FilterByDate
              permission={PERMISION.FINANCE.REGISTER.REFERENCE_ID.PERMISION}
              dateFrom={filter.dateFrom}
              dateTo={filter.dateTo}
              onChangeDateFrom={(dateFrom) => {
                const isValid = moment(dateFrom).isBefore(filter.dateTo)
                handleChangeFilter({
                  dateFrom,
                  dateTo: isValid ? filter.dateTo : dateFrom
                })
              }}
              onChangeDateTo={(dateTo) => handleChangeFilter({ dateTo })}
              onClickPrevYear={() =>
                handleChangeFilter({
                  dateFrom: prevYearDate.fromDate,
                  dateTo: prevYearDate.toDate
                })
              }
              onClickThisYear={() =>
                handleChangeFilter({
                  dateFrom: thisYearDate.fromDate,
                  dateTo: thisYearDate.toDate
                })
              }
              onClickThisWeek={() =>
                handleChangeFilter({
                  dateFrom: thisWeekDate.fromDate,
                  dateTo: thisWeekDate.toDate
                })
              }
              onClickThisMonth={() =>
                handleChangeFilter({
                  dateFrom: thisMonthDate.fromDate,
                  dateTo: thisMonthDate.toDate
                })
              }
              onClickToday={() =>
                handleChangeFilter({
                  dateFrom: todayDate,
                  dateTo: todayDate
                })
              }
            />
          </Card.Body>
        </Card>
      </section>

      <div className="overflow-x-scroll max-h-[calc(100vh-500px)]">
      <section className="mt-2">
        <RowIndexContext.Provider value={getRowNumber}>
          <TableRegister
            data={data}
            filter={filter}
            isLoading={isLoading}
            handleCheckData={handleCheckData}
            fetchList={fetch}
            permission={PERMISION.FINANCE.REGISTER.REFERENCE_ID.PERMISION}
          />
         </RowIndexContext.Provider>
         
         {Boolean(!isLoading && data.length) && (
          <Pagination
            currentPage={currentPage}
            totalPage={totalPage}
            size={size}
            limit={limit}
            total={total}
            onPageChange={onChangePage}
            onAddShow={(res) => onChangeLimit(Number(res))}
          />
          
        )}
      </section>

      <section className="mt-2">
        <FooterMenu
          customRightElement={(
            <FooterSummary
              data={data}
              dateFrom={filter.dateFrom}
            />
          )}
          export={{
            actiontype: "export",
            onClick: () => {
              ExportExcel({
                data: data,
                filter: {
                  dateFrom: filter.dateFrom,
                  dateTo: filter.dateTo
                },
                fileName: "finance_register_by_reference_id",
                title: "FINANCE REGISTER BY REFERENCE ID"
              })
            }
          }}

          pdf={{
            actiontype: "pdf",
            onClick: () => {
              exportPdf({
                documentComponent:
                  <ExportPdf
                    data={data}
                    filter={{
                      dateFrom: filter.dateFrom,
                      dateTo: filter.dateTo
                    }}
                    title="FINANCE REGISTER BY REFERENCE ID"
                  />,
                fileName: "finance_register_by_reference_id"
              })
            }
          }}

        />
      </section>
      </div>
    </Fragment>
  )
}
